import styled from 'styled-components';

import { Button } from 'common/interaction';

export const HomeHeaderButtonContainer = styled(Button)`
  width: 100%;
`;
